import { styled as o } from "styled-components";
import { Theme as n } from "../../../../styles/themes/index.js";
import { CaptionHeavy as e, SmallHeavy as a } from "../../../../styles/typography/index.js";
import { MediaQuery as i } from "../../../../styles/variables.js";
const r = o.div`
  display: inline-block;

  &::before {
    content: '●';
    display: inline-block;
    width: 16px;
    height: 16px;
  }

  ${e}

  span {
    display: none;
  }

  @media ${i.SCREEN_MD_UP} {
    span {
      display: inline-block;
    }
  }
`, c = o(r)`
  ${a};
  color: rgb(${n.colors.Brand});
  margin: 4px 0px 0px 8px;
`, s = o(r)`
  color: rgb(${n.colors.Brand});
`, d = o(r)`
  color: rgb(${n.colors.Brand});
`, g = o(r)`
  color: rgb(${n.colors.Brand});
`;
export {
  r as CommentFlagContainer,
  g as DeletedCommentFlagContainer,
  d as ModeratedCommentFlagContainer,
  c as NewCommentFlagContainer,
  s as PublishingCommentFlagContainer
};
